import { FormsAnalyticsCardIcon } from './FormsAnalyticsCardIcon'
import { FormsAnalyticsCardMetric } from './FormsAnalyticsCardMetric'
import { FormsAnalyticsCardRoot } from './FormsAnalyticsCardRoot'
import { FormsAnalyticsCardSubtitle } from './FormsAnalyticsCardSubtitle'
import { FormsAnalyticsCardTitle } from './FormsAnalyticsCardTitle'
import { FormsAnalyticsCardTitleMinor } from './FormsAnalyticsCardTitleMinor'

export const FormsAnalyticsCard = {
  Root: FormsAnalyticsCardRoot,
  Title: FormsAnalyticsCardTitle,
  TitleMinor: FormsAnalyticsCardTitleMinor,
  Icon: FormsAnalyticsCardIcon,
  Metric: FormsAnalyticsCardMetric,
  Subtitle: FormsAnalyticsCardSubtitle,
}
